/**
 * Central source of truth for the Cal.com demo booking URL.
 * Set REACT_APP_CALCOM_DEMO_URL in /app/frontend/.env
 * Every "Book a Demo" CTA on the site reads from this constant.
 */
export const CALCOM_DEMO_URL =
  process.env.REACT_APP_CALCOM_DEMO_URL || "https://cal.com/cleanbid/30min";
